import React from 'react';
import { WordInfo } from '../models';

type WordProp = {
  wordInfo: WordInfo;
  active: boolean;
  selected?: boolean;
  onClick?: (wordInfo: WordInfo) => void;
  children?: React.ReactNode | null;
};

class Word extends React.Component<WordProp> {
  shouldComponentUpdate(nextProps: WordProp) {
    return (
      nextProps.active !== this.props.active ||
      nextProps.wordInfo.word !== this.props.wordInfo.word ||
      nextProps.children !== this.props.children
    );
  }

  handleClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    this.props.onClick && this.props.onClick(this.props.wordInfo);
  };

  render() {
    const additionalClassNames = (() => {
      let cum = '';
      if (this.props.active) cum = `${cum} active-word`;
      if (this.props.selected) cum = `${cum} focus-word`;
      return cum;
    })();

    return (
      <>
        <span
          className={'word ' + additionalClassNames}
          data-word-id={this.props.wordInfo.id}
          data-start-time={this.props.wordInfo.startTime}
          data-end-time={this.props.wordInfo.endTime}
          onClick={this.handleClick}
        >
          {this.props.children ? this.props.children : this.props.wordInfo.word}
        </span>
      </>
    );
  }
}

type SimpleWordProp = {
  wordInfo: WordInfo;
  active: boolean;
  selected?: boolean;
  onClick?: (wordInfo: WordInfo) => void;
};

class SimpleWord extends React.Component<SimpleWordProp> {
  shouldComponentUpdate(nextProps: WordProp) {
    return (
      nextProps.active !== this.props.active ||
      nextProps.wordInfo.word !== this.props.wordInfo.word ||
      nextProps.selected !== this.props.selected
    );
  }

  handleClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    this.props.onClick && this.props.onClick(this.props.wordInfo);
  };

  render() {
    const additionalClassNames = (() => {
      let cum = '';
      if (this.props.active) cum = `${cum} active-word`;
      if (this.props.selected) cum = `${cum} focus-word`;
      return cum;
    })();

    return (
      <>
        <span
          className={'word ' + additionalClassNames}
          data-word-id={this.props.wordInfo.id}
          data-start-time={this.props.wordInfo.startTime}
          data-end-time={this.props.wordInfo.endTime}
          onClick={this.handleClick}
        >
          {this.props.wordInfo.word}
        </span>
      </>
    );
  }
}

export default Word;
export { SimpleWord };
